export enum SiteSettingActionType {
  // Load Site Settings
  LoadSiteSettings            = 'LOAD_SITE_SETTINGS',
  LoadSiteSettingsCompleted   = 'LOAD_SITE_SETTINGS_COMPLETED',
  LoadSiteSettingsFailed      = 'LOAD_SITE_SETTINGS_FAILED',

  LoadUserProps            = 'LOAD_USER_PROPS',
  LoadUserPropsCompleted   = 'LOAD_USER_PROPS_COMPLETED',
  LoadUserPropsFailed      = 'LOAD_USER_PROPS_FAILED',

  // Update Site Setting
  UpdateSiteSetting           = 'UPDATE_SITE_SETTING',
  UpdateSiteSettingCompleted  = 'UPDATE_SITE_SETTING_COMPLETED',
  UpdateSiteSettingFailed     = 'UPDATE_SITE_SETTING_FAILED',

  // Load Custom Fields
  LoadCustomFields            = 'LOAD_CUSTOM_FIELDS',
  LoadCustomFieldsCompleted   = 'LOAD_CUSTOM_FIELDS_COMPLETED',
  LoadCustomFieldsFailed      = 'LOAD_CUSTOM_FIELDS_FAILED',

  // Update Custom Fields
  UpdateCustomFields           = 'UPDATE_CUSTOM_FIELDS',
  UpdateCustomFieldsCompleted  = 'UPDATE_CUSTOM_FIELDS_COMPLETED',
  UpdateCustomFieldsFailed     = 'UPDATE_CUSTOM_FIELDS_FAILED',

  // Load Email Config
  LoadEmailConfig            = 'LOAD_EMAIL_CONFIG',
  LoadEmailConfigCompleted   = 'LOAD_EMAIL_CONFIG_COMPLETED',
  LoadEmailConfigFailed      = 'LOAD_EMAIL_CONFIG_FAILED',

  // Update Custom Fields
  UpdateEmailConfig           = 'UPDATE_EMAIL_CONFIG',
  UpdateEmailConfigCompleted  = 'UPDATE_EMAIL_CONFIG_COMPLETED',
  UpdateEmailConfigFailed     = 'UPDATE_EMAIL_CONFIG_FAILED',

  // Load Site License
  LoadSiteLicense             = 'LOAD_SITE_LICENSE',
  LoadSiteLicenseCompleted    = 'LOAD_SITE_LICENSE_COMPLETED',
  LoadSiteLicenseFailed       = 'LOAD_SITE_LICENSE_FAILED',

  // Site License
  UpdateSiteLicense             = 'UPDATE_SITE_LICENSE',
  UpdateSiteLicenseCompleted    = 'UPDATE_SITE_LICENSE_COMPLETED',
  UpdateSiteLicenseFailed       = 'UPDATE_SITE_LICENSE_FAILED',


  // Site Supported Language
  LoadSiteSupportedLanguage = 'LOAD_SUPPORTED_LANGUAGE',
  LoadSiteSupportedLanguageCompleted = 'LOAD_SUPPORTED_LANGUAGE_COMPLETED',
  LoadSiteSupportedLanguageFailed = 'LOAD_SUPPORTED_LANGUAGE_FAILED',

  // Site Supported Language
  UpdateSiteSupportedLanguage          = 'UPDATE_SUPPORTED_LANGUAGE',
  UpdateSiteSupportedLanguageCompleted = 'UPDATE_SUPPORTED_LANGUAGE_COMPLETED',
  UpdateSiteSupportedLanguageFailed = 'UPDATE_SUPPORTED_LANGUAGE_FAILED',


  // Backup Translate
  LoadBackupTranslate = 'LOAD_BACKUP_TRANSLATE',
  LoadBackupTranslateCompleted = 'LOAD_BACKUP_TRANSLATE_COMPLETED',
  LoadBackupTranslateFailed = 'LOAD_BACKUP_TRANSLATE_FAILED',

  // Backup Translate
  UpdateBackupTranslate = 'UPDATE_BACKUP_TRANSLATE',
  UpdateBackupTranslateCompleted = 'UPDATE_BACKUP_TRANSLATE_COMPLETED',
  UpdateBackupTranslateFailed = 'UPDATE_BACKUP_TRANSLATE_FAILED',


  // Password Setting
  LoadPasswordSettings = 'LOAD_PASSWORD_SETTINGS',
  LoadPasswordSettingsCompleted = 'LOAD_PASSWORD_SETTINGS_COMPLETED',
  LoadPasswordSettingsFailed = 'LOAD_PASSWORD_SETTINGS_FAILED',

  // Password Setting
  UpdatePasswordSettings = 'UPDATE_PASSWORD_SETTINGS',
  UpdatePasswordSettingsCompleted = 'UPDATE_PASSWORD_SETTINGS_COMPLETED',
  UpdatePasswordSettingsFailed = 'UPDATE_PASSWORD_SETTINGS_FAILED',

  // Usersession Setting
  UpdateUserSessionSettings = 'UPDATE_USERSESSION_SETTINGS',
  UpdateUserSessionSettingsCompleted = 'UPDATE_USERSESSION_SETTINGS_COMPLETED',
  UpdateUserSessionSettingsFailed = 'UPDATE_USERSESSION_SETTINGS_FAILED',

      // Usersession Setting
  LoadUserSessionSettings = 'LOAD_USERSESSION_SETTINGS',
  LoadUserSessionSettingsCompleted = 'LOAD_USERSESSION_SETTINGS_COMPLETED',
  LoadUserSessionSettingsFailed = 'LOAD_USERSESSION_SETTINGS_FAILED',

  CheckSsoKey           = 'CHECK_SSO_KEY',
  CheckSsoKeyCompleted  = 'CHECK_SSO_KEY_COMPLETED',
  CheckSsoKeyFailed     = 'CHECK_SSO_KEY_FAILED',

  UpdateSsoKey           = 'UPDATE_SSO_KEY',
  UpdateSsoKeyCompleted  = 'UPDATE_SSO_KEY_COMPLETED',
  UpdateSsoKeyFailed     = 'UPDATE_SSO_KEY_FAILED',

  UpdateSsoSetting           = 'UPDATE_SSO_SETTING',
  UpdateSsoSettingCompleted  = 'UPDATE_SSO_SETTING_COMPLETED',
  UpdateSsoSettingFailed     = 'UPDATE_SSO_SETTING_FAILED',

  UpdateBannerCheck           = 'UPDATE_BANNER_CHECK',
  UpdateBannerCheckCompleted  = 'UPDATE_BANNER_CHECK_COMPLETED',
  UpdateBannerCheckFailed     = 'UPDATE_BANNER_CHECK_FAILED',

  UpdateBannerMessage           = 'UPDATE_BANNER_MESSAGE',
  UpdateBannerMessageCompleted  = 'UPDATE_BANNER_MESSAGE_COMPLETED',
  UpdateBannerMessageFailed     = 'UPDATE_BANNER_MESSAGE_FAILED',

  LoadMessage           = 'LOAD_MESSAGE',
  LoadMessageCompleted  = 'LOAD_MESSAGE_COMPLETED',
  LoadMessageFailed     = 'LOAD_MESSAGE_FAILED',

  LoadTextMessage           = 'LOAD_TEXT_MESSAGE',
  LoadTextMessageCompleted  = 'LOAD_TEXT_MESSAGE_COMPLETED',
  LoadTextMessageFailed     = 'LOAD_TEXT_MESSAGE_FAILED',

  LoadErrorSSOMessage           = 'LOAD_ERROR_SSO_MESSAGE',
  LoadErrorSSOMessageCompleted  = 'LOAD_ERROR_SSO_MESSAGE_COMPLETED',
  LoadErrorSSOMessageFailed     = 'LOAD_ERROR_SSO_MESSAGE_FAILED',

  UpdateErrorSSOMessage           = 'UPDATE_ERROR_SSO_MESSAGE',
  UpdateErrorSSOMessageCompleted  = 'UPDATE_ERROR_SSO_MESSAGE_COMPLETED',
  UpdateErrorSSOMessageFailed     = 'UPDATE_ERROR_SSO_MESSAGE_FAILED',

  LoadErrorSSOSingleMessage           = 'LOAD_ERROR_SSO_SINGLE_MESSAGE',
  LoadErrorSSOSingleMessageCompleted  = 'LOAD_ERROR_SSO_SINGLE_MESSAGE_COMPLETED',
  LoadErrorSSOSingleMessageFailed     = 'LOAD_ERROR_SSO_SINGLE_MESSAGE_FAILED',

  LoadSSOMetadata           = 'LOAD_SSO_METADATA',
  LoadSSOMetadataCompleted  = 'LOAD_SSO_METADATA_COMPLETED',
  LoadSSOMetadataFailed     = 'LOAD_SSO_METADATA_FAILED',
}
